import { FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { getDefaultCurrency } from 'store/state';
import { SETTLEMENT_TYPE } from 'services/templates/types';
import { isPerUnitSettlement } from 'utils/components/contract-template/distribution/settlementType.utils';

interface IContractInputAgreementShareValueProps {
  id: string;
  settlementType: SETTLEMENT_TYPE;
}

const ContractInputAgreementShareValue = ({
  id,
  settlementType,
}: IContractInputAgreementShareValueProps) => {
  const { itemNameById, displayMode } = useFormikContractHelpers();
  const defaultCurrency = getDefaultCurrency()?.currencyCode ?? '';

  if (isPerUnitSettlement(settlementType)) {
    return (
      <FormInput.Number
        name={`${itemNameById(id)}.content.distributionTemplateShares.amountPerUnit`}
        placeholder={`0 ${defaultCurrency}`}
        suffix={` ${defaultCurrency}`}
        displayMode={displayMode}
      />
    );
  }

  return (
    <FormInput.Number
      name={`${itemNameById(id)}.content.distributionTemplateShares.percent`}
      placeholder='0%'
      suffix='%'
      displayMode={displayMode}
    />
  );
};

export default ContractInputAgreementShareValue;
